<ion-header
  class="ion-no-border"
  [class.header--hidden]="selectedSurvey?.survey"
>
  <ion-toolbar class="app-toolbar">
    <ion-buttons slot="end">
      <ion-button
        appHaptics
        class="close-button"
        color="primary"
        (click)="onLogout()"
        title="Logout"
      >
        Log out
      </ion-button>
    </ion-buttons>
    <ion-title class="ion-no-padding">Updates Since Last Login</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content *ngIf="_isMobile; else content" color="light">
  <ng-container *ngTemplateOutlet="content" />
</ion-content>

<ng-template #content>
  <app-announcement-preview
    *ngIf="selectedAnnouncementIndex !== -1"
    [announcement]="selectedAnnouncement"
    [announcementIndex]="selectedAnnouncementIndex"
    (cancelClicked)="onAnnouncementPreviewClose()"
    (announcementAcknowledged)="onAnnouncementAcknowledged($event)"
    (announcementResponded)="onAnnouncementResponded($event)"
  />

  <app-survey-preview
    *ngIf="selectedSurvey?.survey"
    (cancelClicked)="onSurveyPreviewClose()"
    (surveyCompleted)="onSurveyCompleted()"
    (surveySkipped)="onSurveySkipped()"
    [survey]="selectedSurvey.survey"
    [questions]="selectedSurvey.questions"
  />

  <div
    class="whats-new-container {{
      selectedSurvey?.survey || selectedAnnouncementIndex !== -1
        ? 'whats-new-container--expanded'
        : ''
    }} {{
      !selectedSurvey?.survey && selectedAnnouncementIndex === -1
        ? 'whats-new-container--show'
        : ''
    }}"
  >
    <div
      class="whats-new-section"
      [ngClass]="{
        'whats-new-section--hidden':
          !recognitions.count && !recognitionReminders.count
      }"
    >
      Recognition
    </div>
    <div
      class="whats-new-item whats-new-item--recognitionReminder"
      *ngFor="
        let reminder of recognitionReminders.items;
        let i = index;
        trackBy: trackRemindersBy
      "
      [attr.data-index]="i"
      [attr.data-id]="reminder.title"
    >
      <app-whats-new-item
        [title]="reminder.title"
        [buttons]="recognitionReminderButtons"
        (buttonClicked)="whatsNewItemButtonClick($event)"
      />
    </div>
    <div
      class="whats-new-item whats-new-item--recognition"
      *ngFor="
        let post of recognitions.items;
        let i = index;
        trackBy: trackRecognitionsBy
      "
      [attr.data-index]="i"
      [attr.data-id]="post._id.toString()"
    >
      <app-recognition-item
        [item]="post"
        [showOptions]="authenticatedUser._id === post.sender?._id || isAdmin"
        [showEditButton]="false"
        [showPrivateButton]="false"
        [showMarkAsReadButton]="true"
        (markAsReadClicked)="readRecognition(post, i)"
        appHaptics
        [disableHaptics]="
          !(authenticatedUser._id === post.sender?._id || isAdmin)
        "
        [showPoints]="showRecognitionPoints"
      />
    </div>
    <div
      class="whats-new-section whats-new-section--bottom"
      [ngClass]="{
        'whats-new-section--hidden':
          recognitions.totalCount <= recognitions.count
      }"
    >
      + {{ recognitions.totalCount - recognitions.count }} more
    </div>

    <div
      class="whats-new-section"
      [ngClass]="{ 'whats-new-section--hidden': !announcements.count }"
    >
      Critical Announcements
    </div>
    <div
      *ngFor="
        let announcement of announcements.items;
        let i = index;
        trackBy: trackAnnouncementsBy
      "
      class="whats-new-item whats-new-item--announcement"
      [attr.data-index]="i"
      [attr.data-id]="announcement._id"
    >
      <app-announcement-item
        [announcement]="announcement"
        (click)="onAnnouncementClick(announcement, i)"
        appHaptics
      />
    </div>
    <div
      class="whats-new-section whats-new-section--bottom"
      [ngClass]="{
        'whats-new-section--hidden':
          announcements.totalCount <= announcements.count
      }"
    >
      + {{ announcements.totalCount - announcements.count }} more
    </div>

    <div
      class="whats-new-section"
      [ngClass]="{ 'whats-new-section--hidden': !surveys.count }"
    >
      Team Health
    </div>
    <div
      class="whats-new-item whats-new-item--survey"
      *ngFor="
        let survey of surveys.items;
        let i = index;
        trackBy: trackSurveysBy
      "
      [attr.data-index]="i"
      [attr.data-id]="survey.survey._id.toString()"
    >
      <app-survey-item
        [titleHtml]="'Team Feedback'"
        [points]="surveyPoints"
        (buttonClicked)="onSurveyClick(survey)"
        (skipClicked)="onSurveySkip(survey, i)"
      />
    </div>
    <div
      class="whats-new-section whats-new-section--bottom"
      [ngClass]="{
        'whats-new-section--hidden': surveys.totalCount <= surveys.count
      }"
    >
      + {{ surveys.totalCount - surveys.count }} more
    </div>
  </div>
</ng-template>
